export const DCGame = () => {

	return(
		<>

		</>
	);
};